"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Image;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Image(_ref) {
  var moduleClass = _ref.moduleClass,
      url = _ref.url,
      image_title = _ref.image_title,
      alt = _ref.alt;

  return _react2.default.createElement(
    "div",
    {
      className: "type-image " + moduleClass
    },
    _react2.default.createElement(
      "div",
      { className: "job-image" },
      _react2.default.createElement("img", {
        src: url,
        alt: alt,
        title: image_title
      })
    )
  );
} /*
     {
       "type": "image",
       "title": "An optional title",
       "url": "http://path/to/image",
       "caption": "Photo Caption",
       "image_title": "Photo Title",
       "alt": "Photo alt"
     }
  
     For displaying an image. Accepts the following attributes:
  
     url - the URL of the image
  - `title` - An optional title to display above the image
     caption - an optional caption to show below the image
  - `image_title` - the title attribute of the image
     alt - alt text attribute of the image
  */

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/Image/Image.jsx
// module id = 1167
// module chunks = 0